<template>
  <router-view />
</template>

<script lang="ts">
export default {
  name: "RouterViewGenerico"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
